export default "__VITE_ASSET__C_rDivy6__"